import { isEmail } from './is-email';

export function validateEmail(email: unknown): true | string {
  return isEmail(email) || 'Recheck your email address';
}
